// extracted by mini-css-extract-plugin
export var avatarContainer = "_ei-0";
export var gray = "_ei-f";
export var green = "_ei-c";
export var icon = "_ei-9";
export var image = "_ei-1";
export var lg = "_ei-6";
export var md = "_ei-5";
export var presenceDot = "_ei-b";
export var red = "_ei-d";
export var sm = "_ei-4";
export var status = "_ei-a";
export var xl = "_ei-7";
export var xs = "_ei-3";
export var xxl = "_ei-8";
export var xxs = "_ei-2";
export var yellow = "_ei-e";